import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
type Props = {
  children: ReactNode;
  appContext: AppContext;
};
const INITIAL_CONTEXT = {};
export const B2CAppContext = createContext<AppContext>(INITIAL_CONTEXT);
export const B2CAppContextProvider = ({ children, appContext }: Props) => {
  return <B2CAppContext.Provider value={appContext}>{children}</B2CAppContext.Provider>;
};
export const useAppContext = (): AppContext => {
  const context = useContext<AppContext>(B2CAppContext);

  if (context === INITIAL_CONTEXT) {
    throw new Error('useAppContext must be used within a B2CAppContext.Provider');
  }

  return context;
};
